<template>
  <div class="newsInfo">
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">路况发布</h2>
      <!--      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改应急队伍</h2>-->
      <Divider/>
      <div style="width: 80%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="标题" prop="title">
            <Input v-model="formValidate.title" placeholder="请填写标题"></Input>
          </FormItem>
          <!--          <FormItem label="发布时间" prop="releaseTime">-->
          <!--            <DatePicker transfer type="datetime" placeholder="请选择发布时间"-->
          <!--                        v-model="formValidate.releaseTime"></DatePicker>-->
          <!--          </FormItem>-->
          <FormItem label="开始时间" prop="startTime">
            <DatePicker transfer type="datetime" placeholder="请选择开始时间"
                        v-model="formValidate.startTime"></DatePicker>
          </FormItem>
          <FormItem label="结束时间" prop="endTime">
            <DatePicker transfer type="datetime" placeholder="请选择结束时间"
                        v-model="formValidate.endTime"></DatePicker>
          </FormItem>
          <FormItem label="紧急程度" prop="color">
            <Select v-model="formValidate.color" placeholder="请选择紧急程度">
              <Option v-for="(item,index) in colorList" :value="item.id" :label="item.name" :key="index"></Option>
            </Select>
          </FormItem>
          <FormItem label="封面" prop="cover">
            <!--            <Input v-model="formValidate.cover" placeholder="请填写新闻封面"></Input>-->
            <Upload
              :headers="coverHeaders"
              :show-upload-list="false"
              :on-success="coverSuccess"
              :action="$uploadUrl+'/api/file/uploadToLocal'">
              <Button icon="ios-cloud-upload-outline">上传封面</Button>
            </Upload>
            <span v-if="formValidate.cover !== ''">
                          {{ formValidate.cover.split('/')[5] }}
                          <Icon type="md-close"
                                @click="delCoverFilePath"
                                style="float: right;margin-right: 30px;line-height: 30px"/>
                        </span>
          </FormItem>
          <FormItem label="点位">
            <Button @click="pointModalShow()">设置点位</Button>
            <br>
            <div v-if="$refs.pointMap">
            <span style="display: inline-block;width: 100%;" v-for="(item,index) in  pointLists"
                  :key="index">{{ index + 1 }}.经度：{{ item.longitude }}纬度{{
                item.latitude
              }}</span>
            </div>
          </FormItem>
          <FormItem label="施工描述" prop="description">
            <Input v-model="formValidate.description" type="textarea"></Input>
          </FormItem>
          <FormItem label="施工地点" prop="position">
            <Input v-model="formValidate.position"></Input>
          </FormItem>
          <FormItem label="施工单位" prop="unit">
            <Input v-model="formValidate.unit"></Input>
          </FormItem>
          <FormItem label="封控情况" prop="lockdownSituation">
            <Input v-model="formValidate.lockdownSituation" type="textarea"></Input>
          </FormItem>
<!--          <FormItem label="监管情况" prop="superviseSituation">-->
<!--            <Input v-model="formValidate.superviseSituation" type="textarea"></Input>-->
<!--          </FormItem>-->
          <!--          <FormItem label="发布内容" prop="content">-->
          <!--            <div style="text-align: right">-->
          <!--              <Button type="text" size="small" @click="previewRich()" style="color: #2d8cf0;">预览</Button>-->
          <!--            </div>-->
          <!--            <news-editor :content="formValidate.content" @childEvent="getRichText"-->
          <!--                         @editEvent="setRichText"></news-editor>-->
          <!--            <Card :dis-hover="true" v-if="showPreview">-->
          <!--              <Icon type="md-close"-->
          <!--                    @click="closePreview"-->
          <!--                    style="float: right;margin-right: 30px;line-height: 30px"/>-->
          <!--              <div v-html="preview" style="text-align: left;"></div>-->
          <!--            </Card>-->
          <!--          </FormItem>-->
        </Form>
        <div style="text-align: center">
          <Button v-if="!formValidate.id" type="primary" @click="handleSubmit('formValidate',0)" :loading="saveLoading">保存</Button>
          <Button v-if="formValidate.id" type="primary" @click="editNews('formValidate',0)">编辑</Button>
          <Button v-if="!formValidate.id" type="primary" @click="handleSubmit('formValidate',1)"
                  :loading="releaseLoading"
                  style="margin-left: 8px">发布
          </Button>
          <Button v-if="formValidate.id" type="primary" @click="editNews('formValidate',1)" style="margin-left: 8px">
            发布
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </div>
      </div>
    </Card>
    <Modal v-model="pointModalIsShow"
           @on-visible-change="pointModalVisibleChange"
           :width="80"
           title="点位拾取">
      <PointMap ref="pointMap" :pointLists="pointLists"></PointMap>
      <div slot="footer">
        <Button @click="pointModalIsShow = false">取消</Button>
        <Button type="primary" @click="pointModalIsShow = false">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import NewsEditor from '@/views/newsRelease/components/NewsRelease/newsInfo/components/editor.vue'
import PointMap from "@/views/newsRelease/components/NewsRelease/newsInfo/components/pointMap.vue";

export default {
  name: "newsInfo",
  components: {NewsEditor, PointMap},
  data() {
    return {
      saveLoading: false, // 保存按钮loading
      pointModalIsShow: false,
      colorList: [],
      pointLists: [],
      releaseLoading: false, // 发布按钮loading
      uploading: false,
      countryList: [],
      warningTypeList: [],
      showPreview: false,
      preview: '',
      coverHeaders: {Authorization: localStorage.getItem('token')},
      formValidate: {
        title: '',
        cover: '',
        releaseTime: '',
        content: '',
        color: '',
        startTime: '',
        endTime: '',
        description: '',
        position: '',
        unit: '',
        lockdownSituation: '',
        superviseSituation: ''
      },
      ruleValidate: {
        title: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        cover: [
          {required: false, message: '必填', trigger: 'blur'}
        ],
        releaseTime: [
          {required: true, type: 'date', message: '必填', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        color: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        startTime: [
          {required: true, type: 'date', message: '必填', trigger: 'blur'}
        ],
        endTime: [
          {required: true, type: 'date', message: '必填', trigger: 'blur'}
        ],
        description: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        position: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        unit: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        lockdownSituation: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
        superviseSituation: [
          {required: true, message: '必填', trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    this.getColor()
    if (this.$route.params.row) {
      this.formValidate = this.$route.params.row
      console.log(this.formValidate)
      this.pointLists = this.formValidate.positionList
    }
  },
  methods: {
    pointModalVisibleChange(val) {
      if (val) {
        this.$refs.pointMap.addPoint()
      }
    },
    // 获取紧急程度颜色
    getColor() {
      this.$http.get(`/api/newsColors`).then(res => {
        if (res) {
          this.colorList = res.data.data
        }
      })
    },
    pointModalShow() {
      this.pointModalIsShow = true
    },
    coverSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      let fileInfo = response.split(', ')
      let filePath = fileInfo[3].slice(0, -2)
      this.formValidate.cover = filePath.split('=')[1]
      this.uploading = false
    },
    coverBeforeUpload() {
      this.uploading = true
    },
    delCoverFilePath() {
      this.formValidate.cover = ''
    },
    getRichText(data) {
      console.log(data)
      this.formValidate.content = data.richText
    },
    setRichText(data) {
      console.log(data)
      // var editor = data.editor
      // editor.setHtml(this.formValidate.content)
    },
    previewRich() {
      this.showPreview = true
      this.preview = this.formValidate.content
    },
    closePreview() {
      this.showPreview = false
      this.preview = ''
    },
    handleSubmit(name, status) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          // if (this.$refs.pointMap.pointList.length === 0) {
          //   this.$Message.error('请添加点位')
          //   return
          // }
          // this.releaseLoading = true

          let pointList = []
          for (let i in this.pointLists) {
            pointList[i] = []
            pointList[i][0] = this.pointLists[i].longitude
            pointList[i][1] = this.pointLists[i].latitude
            pointList[i][2] = this.pointLists[i].timeStamp
          }
          console.log(pointList.join(';'))
          let params = {...this.formValidate, longitudeAndLatitudes: pointList.join(';')}
          // var blob = new Blob([this.formValidate.content])
          // params.content = blob
          params.status = status
          console.log(params)
          this.$http.post('/api/insertNewsReleases', params).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.saveLoading = false
              // this.releaseLoading = false
              this.$Message.success('新增完成！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'newsRelease'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        }
      })
    },
    editNews(name, status) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let pointList = []
          for (let i in this.$refs.pointMap.pointLists) {
            pointList[i] = []
            pointList[i][0] = this.pointLists[i].longitude
            pointList[i][1] = this.pointLists[i].latitude
            //pointList[i][2] = this.pointLists[i].locTime
            if (this.pointLists[i].locTime) {
              pointList[i][2] = this.pointLists[i].locTime
            } else {
              pointList[i][2] = this.pointLists[i].timeStamp
            }
          }
          console.log(pointList.join(';'))
          let params = {...this.formValidate, longitudeAndLatitudes: pointList.join(';')}
          params.status = status
          this.$http.put('/api/updateNewsReleases', params).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('编辑完成！')
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'newsRelease'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.newsInfo {

}
</style>
